'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _cms = require('actions/cms');

var _Contact = require('components/Contact/Contact');

var _Contact2 = _interopRequireDefault(_Contact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var data = state.cms.contact;
  var loading = state.cms.loading;

  var hero = {};
  var office = {};
  var studio = {};
  var team = {};

  if (data !== null) {
    var page = data[0];
    var teamMembers = [];

    page.getGroup('contact.team-member').toArray().map(function (item) {
      var image = item.getImage('team-member-image').url;
      var name = item.getText('team-member-name');
      var role = item.getText('team-member-role');

      teamMembers.push({
        image: image,
        name: name,
        role: role
      });
    });

    hero = {
      image: page.getImage('contact.image').url,
      email: page.getText('contact.email'),
      telephone: page.getText('contact.telephone')
    };

    office = {
      title: page.getText('contact.office-title'),
      line1: page.getText('contact.office-line-1'),
      line2: page.getText('contact.office-line-2'),
      line3: page.getText('contact.office-line-3'),
      gmap: page.getText('contact.office-gmap-url')
    };

    studio = {
      title: page.getText('contact.studio-title'),
      line1: page.getText('contact.studio-line-1'),
      line2: page.getText('contact.studio-line-2'),
      line3: page.getText('contact.studio-line-3'),
      gmap: page.getText('contact.studio-gmap-url')
    };

    team = {
      title: page.getText('contact.team-title'),
      team: teamMembers,
      strap: page.getText('contact.strap')
    };
  }

  return {
    data: data,
    hero: hero,
    office: office,
    studio: studio,
    team: team,
    loading: loading
  };
}; /**
    * Contact
    *
    */


var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  return {
    fetchContact: function fetchContact() {
      dispatch((0, _cms.fetchContact)());
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Contact2.default);


//////////////////
// WEBPACK FOOTER
// ./src/containers/Contact.js
// module id = 344
// module chunks = 1